import * as actionType from "../Actions/Action_Type";
import * as ROLES from "../Utils/Roles_Types.js";
import { LABEL_UsrAndPswError } from "../Utils/Strings/Labels";
import { checkUserLanguage } from "../Utils/Check_Value";

const USERINFO      = JSON.parse(localStorage.getItem(ROLES.USERINFO_KEY));
const USERLANGUAGE  = checkUserLanguage(USERINFO);

const initialState = {
    isFetching                : false,
    isAuthenticated           : false,
    errorMessage              : null,
    dialogLoginOpened         : false,
    loginError                : null,
    userInfoFetching          : false
};

const indexReducer = (state = initialState, action) => {
    switch (action.type){
        case actionType.AUTHENTICATION_OPEN_LOGIN_DIALOG : 
                return Object.assign({}, state, {
                    dialogLoginOpened : true
                })
        case actionType.AUTHENTICATION_CLOSE_LOGIN_DIALOG : 
                return Object.assign({}, state, {
                    dialogLoginOpened : true
                })
            //CAMBIO PASSWORD
        case actionType.AUTHENTICATION_LOGIN_REQUEST:
            return Object.assign({}, state, {
                isFetching      : true,
                isAuthenticated : false,
                loginMessage    : null,
                errorMessage    : null,
                user            : action.info,
                usernameError   : null,
                passwordError   : null
            });
        case actionType.AUTHENTICATION_LOGIN_SUCCESS:
            debugger;
            return Object.assign({}, state, {
                isFetching      : false,
                isAuthenticated : true,
                errorMessage    : null,
                loginMessage    : "Benvenuto",
                usernameError   : null,
                passwordError   : null
        });
        case actionType.AUTHENTICATION_LOGIN_ERROR:
            console.log(action);
            return Object.assign({}, state, {
                isFetching      : false,
                isAuthenticated : false,
                loginError      : action.msgError === "Password o nome utente errato." ? LABEL_UsrAndPswError[USERLANGUAGE] : action.msgError,
                usernameError   : action.passwordError,
                passwordError   : action.usernameError
            });
            //USERINGO
        case actionType.SERVICE_USERINFO_REQUEST :
            return Object.assign({}, state, {
                userInfoFetching : true,
            })
        case actionType.SERVICE_USERINFO_SUCCESS :
            var response = action.response;
            //salvo i dati dell'utente
            if(response.hasOwnProperty("IDUser") && response.hasOwnProperty("Username") && response.hasOwnProperty("Role")){
                localStorage.setItem(ROLES.USERINFO_KEY, JSON.stringify(response));
                return Object.assign({}, state, {
                userInfoFetching      : false,
                isAuthenticated : action.authenticated || false,
                userInfo        : response
                })
            }else{
                return Object.assign({}, state, {
                userInfoFetching  : false,
                isAuthenticated   : false,
                userInfo          : null
                })
            }
            case actionType.SERVICE_USERINFO_ERROR :
            return Object.assign({}, state, {
                userInfoFetching    : false,
                userInfo            : null,
                isAuthenticated     : false
            });
                default:
                    return state;
            }
};

export default indexReducer;


// WEBPACK FOOTER //
// ./src/Reducers/Reducer_Index.js